module.exports = __webpack_public_path__ + "media/images/consultorio4-44659ac3f722e8dc629bc8d03208550a.svg";